export default {
  initForm: state => {
    state.form = {
      preViewImage: '',
      profileRawFile: null,
      profileFileInfo: null,
      invitationNo: '',
      smileNo: '',
      userNo: '',
      category: '',
      hasSecond: false,
      type: '',
      firstName: '',
      secondName: '',
      eventDate: '',
      eventDateTime: '',
      firstRelation: [
        { relation: '부', name: '' },
        { relation: '모', name: '' }
      ],
      secondRelation: [
        { relation: '부', name: '' },
        { relation: '모', name: '' }
      ],
      address: '',
      buildingName: '',
      parkingNote: '',
      transportNote: '',

      firstAccounts: [
        {
          accountHolder: '',
          bank: '선택(은행)',
          accountNumber: ''
        }
      ],
      secondAccounts: [
        {
          accountHolder: '',
          bank: '선택(은행)',
          accountNumber: ''
        }
      ],
      galleryRawFiles: [], // 갤러리에서 새로 등록할 이미지들
      galleryFileList: [], // 기존 저장된 이미지들
      gallery: []
    };
  },

  setPreViewImage: (state, preViewImage = '') => {
    state.form.preViewImage = preViewImage;
  },
  setForm: (state, form = {}) => {
    state.form = Object.assign(state.form, form);
  },
  setList: (state, list = []) => {
    state.list = [...state.list, ...list];
  },

  setNextId: (state, nextId = null) => {
    state.nextId = nextId;
  },

  setDetail: (state, detail = {}) => {
    state.detail = Object.assign({}, detail);
  },

  setCategory: (state, category = '') => {
    state.form.category = category;
  },

  initList: state => {
    state.list = [];
    state.nextId = null;
  },

  mergeList: (state, list = []) => {
    state.list = list;
  }
};
